import styled, { css } from 'styled-components';

import { getColour } from '../Button/SharedLink';
import type { LinkType } from '../Button/SharedLink';

const linkType: LinkType = 'SECONDARY';

const linkCSS = css`
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => getColour(theme, linkType)};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => getColour(theme, linkType, 'HOVER')};
    text-decoration: underline;
    text-underline-offset: ${({ theme }) => theme.spacing.S4};
  }

  &:active {
    color: ${({ theme }) => getColour(theme, linkType, 'ACTIVE')};
    text-decoration: underline;
    text-underline-offset: ${({ theme }) => theme.spacing.S4};
  }

  &:focus-visible {
    border-width: 2px;
    border-style: solid;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    outline: 2px solid ${({ theme }) => theme.colors.BLUE};
    outline-offset: 0;
    color: ${({ theme }) => getColour(theme, linkType, 'FOCUS')};
  }

  &.focus-visible {
    border-width: 2px;
    border-style: solid;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    border-color: transparent;
    outline-offset: 0;
    color: ${({ theme }) => {
      return getColour(theme, linkType, 'FOCUS');
    }};
  }

  &:active &:focus:not(.focus-visible) {
    outline: none;
  }
`;

const Heading = styled.p`
  ${({ theme }) => theme.fontSize.M16};

  &:after {
    content: '';
    display: block;
    padding-top: ${({ theme }) => theme.spacing.S8};
    border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
  }

  a {
    ${linkCSS};
  }
`;

const ListContainer = styled.ul`
  ${({ theme }) => theme.fontSize.M14};
  padding: ${({ theme }) => theme.spacing.S8};
  color: ${({ theme }) => theme.colors.GREY};

  a {
    ${linkCSS};
  }
`;

const ListItem = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  &:last-child {
    margin-bottom: 0;
  }
`;

const HtmlInfoPanelContainer = styled.div`
  max-width: 272px;
`;

export { Heading, ListContainer, ListItem, HtmlInfoPanelContainer };
